<template>
  <div class="mainMyFolder alibabaPuHuiTiFontFamily">
    <v-text-field v-model="searchKeyword"
                  @keyup.enter.native="searchInputEnter"
                  id="keywordInputArea_globeOperation" dense outlined placeholder="搜索我的文件"
                  dark hide-details color="#ffffff" style="width:308px;background:#2a2a2a;">
      <template v-slot:append>
        <p style="font-size:16px;font-weight:bold;color:#ffffff;cursor:pointer;" @click="searchInputEnter"
           class="iconfontFamily mt-1">
          &#xe630;</p>
      </template>
    </v-text-field>
    <div v-if="totalFileList.length !== 0"
         style="width: 308px;height: 58px;line-height: 58px; position: relative">
      <div v-if="!isBatchDeleteFiles" style="width: 100%;display: flex">
        <div @click="isOrderListFolded = !isOrderListFolded" style="cursor:pointer;display: flex"
             :style="{'color': isOrderListFolded ? 'rgba(166,166,166,1)' : 'rgba(255,255,255,1)'}">
          <p style="font-size:16px;" class="alibabaPuHuiTiFontFamily">{{ this.$store.state.orderField }}</p>
          <p class="iconfontFamily" style="font-size: 16px; margin-left: 8px;">&#xe650;</p>
        </div>
        <v-spacer></v-spacer>
        <div v-if="!isOrderListFolded" class="order-menu">
          <div @click="$store.state.orderField = '更新时间';isOrderListFolded = !isOrderListFolded" class="order-item"
               style="margin-top: 12px">
            <div style="width: 6px;height: 6px;border-radius: 50%;margin-left: 10px;"
                 :style="{'background-color' : this.$store.state.orderField === '更新时间' ? 'rgba(77,160,255,1)' : 'transparent'}"></div>
            <div style="margin-left: 10px"
                 :style="{'color' : this.$store.state.orderField === '更新时间' ? 'white' : 'rgba(166,166,166,1)'}"
                 class="SiYuanHeiTi">更新时间
            </div>
          </div>
          <div @click="$store.state.orderField = '创建时间';isOrderListFolded = !isOrderListFolded" class="order-item">
            <div style="width: 6px;height: 6px;border-radius: 50%;margin-left: 10px;"
                 :style="{'background-color' : this.$store.state.orderField === '创建时间' ? 'rgba(77,160,255,1)' : 'transparent'}"></div>
            <div style="margin-left: 10px"
                 :style="{'color' : this.$store.state.orderField === '创建时间' ? 'white' : 'rgba(166,166,166,1)'}"
                 class="SiYuanHeiTi">创建时间
            </div>
          </div>
          <div @click="$store.state.orderField = '标记数量';isOrderListFolded = !isOrderListFolded" class="order-item">
            <div style="width: 6px;height: 6px;border-radius: 50%;margin-left: 10px;"
                 :style="{'background-color' : this.$store.state.orderField === '标记数量' ? 'rgba(77,160,255,1)' : 'transparent'}"></div>
            <div style="margin-left: 10px"
                 :style="{'color' : this.$store.state.orderField === '标记数量' ? 'white' : 'rgba(166,166,166,1)'}"
                 class="SiYuanHeiTi">标记数量
            </div>
          </div>
          <div style="width: 90%;border-bottom: 1px solid rgba(128,128,128,1);margin-left: 6px"></div>
          <div @click="$store.state.orderType = '降序';isOrderListFolded = !isOrderListFolded" class="order-item">
            <div style="width: 6px;height: 6px;border-radius: 50%;margin-left: 10px;"
                 :style="{'background-color' : this.$store.state.orderType === '降序' ? 'rgba(77,160,255,1)' : 'transparent'}"></div>
            <div style="margin-left: 10px"
                 :style="{'color' : this.$store.state.orderType === '降序' ? 'white' : 'rgba(166,166,166,1)'}"
                 class="SiYuanHeiTi">降序
            </div>
          </div>
          <div @click="$store.state.orderType = '升序';isOrderListFolded = !isOrderListFolded" class="order-item">
            <div style="width: 6px;height: 6px;border-radius: 50%;margin-left: 10px;"
                 :style="{'background-color' : this.$store.state.orderType === '升序' ? 'rgba(77,160,255,1)' : 'transparent'}"></div>
            <div style="margin-left: 10px"
                 :style="{'color' : this.$store.state.orderType === '升序' ? 'white' : 'rgba(166,166,166,1)'}"
                 class="SiYuanHeiTi">升序
            </div>
          </div>
        </div>
        <p @click="isFilterFolded = !isFilterFolded" class="iconfontFamily"
           style="font-size: 20px; color: rgba(166,166,166,1); cursor:pointer;"
           :style="{'color': isFilterFolded ? 'rgba(166,166,166,1)' : 'rgba(255,255,255,1)'}">&#xe6a3;</p>
        <div v-if="!isFilterFolded" class="filter-menu">
          <div @click="$store.state.filterField = '全部';isFilterFolded = !isFilterFolded" class="order-item"
               style="margin-top: 12px">
            <div style="width: 6px;height: 6px;border-radius: 50%;margin-left: 10px;"
                 :style="{'background-color' : this.$store.state.filterField === '全部' ? 'rgba(77,160,255,1)' : 'transparent'}"></div>
            <div style="margin-left: 10px"
                 :style="{'color' : this.$store.state.filterField === '全部' ? 'white' : 'rgba(166,166,166,1)'}"
                 class="SiYuanHeiTi">全部文件
            </div>
          </div>
          <div @click="$store.state.filterField = '个人文件';isFilterFolded = !isFilterFolded" class="order-item">
            <div style="width: 6px;height: 6px;border-radius: 50%;margin-left: 10px;"
                 :style="{'background-color' : this.$store.state.filterField === '个人文件' ? 'rgba(77,160,255,1)' : 'transparent'}"></div>
            <div style="margin-left: 10px"
                 :style="{'color' : this.$store.state.filterField === '个人文件' ? 'white' : 'rgba(166,166,166,1)'}"
                 class="SiYuanHeiTi">个人文件
            </div>
          </div>
          <div @click="$store.state.filterField = '团队文件';isFilterFolded = !isFilterFolded" class="order-item">
            <div style="width: 6px;height: 6px;border-radius: 50%;margin-left: 10px;"
                 :style="{'background-color' : this.$store.state.filterField === '团队文件' ? 'rgba(77,160,255,1)' : 'transparent'}"></div>
            <div style="margin-left: 10px"
                 :style="{'color' : this.$store.state.filterField === '团队文件' ? 'white' : 'rgba(166,166,166,1)'}"
                 class="SiYuanHeiTi">团队文件
            </div>
          </div>
          <div
              style="width: 90%;border-bottom: 1px solid rgba(128,128,128,1);margin-left: 6px;margin-bottom: 6px;margin-top: 6px"></div>
          <div @click="deleteMultiFile" class="order-item">
            <div style="margin-left: 26px;color: rgba(166,166,166,1)" class="SiYuanHeiTi">批量操作
            </div>
          </div>
        </div>
      </div>
      <div v-if="isBatchDeleteFiles" style="width: 100%;display: flex;">
        <p style="color: white;padding-left: 2px">{{ multiSelectedFileId.length }} 选中</p>
        <v-spacer></v-spacer>
        <p @click="confirmMultiFileDelete" style="cursor: pointer;color: rgba(166,166,166,1);margin-right: 14px">
          删除</p>
        <p @click="cancelMultiFileDelete" style="cursor: pointer;color: rgba(166,166,166,1)">取消</p>
      </div>
    </div>
    <div v-if="totalFileList.length === 0"
         style="color: rgba(166,166,166);display: flex;align-items: center;width: 100%;height: 100%;justify-content: center"
         class="alibabaPuHuiTiFontFamily">
      暂无文件内容
    </div>
    <div style="width: 100%;overflow: scroll;scrollbar-width: none" :style="{'height' : showCgSlogan ? 'calc(80%)' : '100%'}">
      <div v-for="(item, index) in showFileList" :key="index" class="alibabaPuHuiTiFontFamily">
        <div @click="selectFile(item)" class="card-item" style="display: block"
             :style="{'height' : selectedFileId === item['fileId'] && item['authority'] === 0 ? '120px' : '84px', 'border' : (selectedFileId === item['fileId'] || (isBatchDeleteFiles && item['authority'] === 0 && multiSelectedFileId.indexOf(item['fileId']) > -1)) ? '1px solid rgb(97,171,255)' : '1px solid rgb(128,128,128)'}">
          <div style="display: flex">
            <div class="file-name">
              <p style="color: whitesmoke;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">
                {{ item['fileName'] }}</p>
              <div style="margin-top: 12px;">
                <div v-if="item['authority'] === 0"
                     style="color: whitesmoke;display: flex;height: 21px;line-height: 21px">
                  <p class="iconfontFamily"
                     :style="{'color' : item['labelCount'] > 10000 ? 'red' : item['labelCount'] > 2000 ? 'rgba(255,141,26,1)' : 'rgba(0,201,81,1)'}">
                    &#xe6b0;</p>
                  <p style="margin-left: 12px">对象数量: {{ item['labelCount'] }}</p>
                </div>
                <div v-if="item['authority'] === 1" style="display: flex; ">
                  <div class="alibabaPuHuiTiFontFamily team-icon">团队</div>
                  <div style="display: flex;margin-left: 16px">
                    <!--                    <div class="avatar-icon" :style="{'background-image': 'url(' + item['avatar'] + ')'}"></div>-->
                    <div v-for="(member, idx) in item['teamList']" :key="idx">
                      <div class="avatar-icon" style="margin-left: -3px"
                           :style="{'background-image': 'url(' + member + ')'}"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="!isBatchDeleteFiles" @click="showFileDetail(item)" class="hover-show">
              <p class="iconfontFamily" style="color: white">&#xe6ad;</p>
              <p style="font-size: 14px;color: white;">详情查看</p>
            </div>
          </div>
          <div v-if="selectedFileId === item['fileId'] && item['authority'] === 0">
            <div style="border-bottom: 1px solid rgba(84,84,84,1);width: calc(100% - 10px);margin-left: 5px"></div>
            <div style="color: white;font-size: 18px;display: flex;height: 40px;line-height: 32px;position: relative">
              <v-tooltip bottom nudge-right="13" nudge-top="15" color="rgba(128,128,128,1)">
                <template v-slot:activator="{ on, attrs }">
                  <div v-on="on" v-bind="attrs">
                    <div @click="shareFile(item)" style="font-size:16px;margin-left:20px;color: #ffffff;cursor: pointer"
                         class="iconfontFamily">&#xe6b3;
                    </div>
                  </div>
                </template>
                <span style="color: white;font-size: 12px">分享</span>
              </v-tooltip>
              <v-tooltip bottom nudge-right="13" nudge-top="15" color="rgba(128,128,128,1)">
                <template v-slot:activator="{ on, attrs }">
                  <div v-on="on" v-bind="attrs">
                    <div @click="backupFile(item)"
                         style="font-size:16px;margin-left:20px;color: #ffffff;cursor: pointer"
                         class="iconfontFamily">&#xe8b0;
                    </div>
                  </div>
                </template>
                <span style="color: white;font-size: 12px">备份</span>
              </v-tooltip>
              <v-tooltip bottom nudge-right="13" nudge-top="15" color="rgba(128,128,128,1)">
                <template v-slot:activator="{ on, attrs }">
                  <div v-on="on" v-bind="attrs">
                    <div @click="downloadFile()" style="font-size:16px;margin-left:20px;color: #ffffff;cursor: pointer"
                         class="iconfontFamily">&#xe6b2;
                    </div>
                  </div>
                </template>
                <span style="color: white;font-size: 12px">下载</span>
              </v-tooltip>
              <v-menu end nudge-right="30">
                <template v-slot:activator="{ on, attrs }">
                  <div v-on="on" v-bind="attrs" style="margin-left: 160px;font-size: 16px" class="iconfontFamily">
                    &#xec1c;
                  </div>
                </template>
                <div style="background-color: rgba(56,56,56,1);width: 120px;height: 128px;text-align: center;"
                     class="py-2">
                  <div class="order-item">
                    <div @click="transferToTeamFile(item)"
                         style="color: white;width: 100%;text-align: center;cursor: pointer"
                         class="SiYuanHeiTi">转为团队文件
                    </div>
                  </div>
                  <div @click="renameFile(item)" class="order-item">
                    <div style="color: white;width: 100%;text-align: center;cursor: pointer"
                         class="SiYuanHeiTi">重命名
                    </div>
                  </div>
                  <div @click="deleteFile(item)" class="order-item">
                    <div style="color: white;width: 100%;text-align: center;cursor: pointer"
                         class="SiYuanHeiTi">删除
                    </div>
                  </div>
                </div>
              </v-menu>
            </div>
          </div>
          <div v-if="isBatchDeleteFiles && item['authority'] === 0" style="right: 9px;top: 7px;position: absolute">
            <el-checkbox v-model="multiSelectedFileId.indexOf(item['fileId']) > -1"
                         @change="selectFile(item)"></el-checkbox>
          </div>
        </div>
      </div>
      <my-folder-page-number ref="myFolderPageNumber" style="margin-top: 15px;display: flex;align-items: center;height: 35px;width: 100%" v-if="totalPageNum > 1" :totalPageNum="totalPageNum" :currPageNum="currPageNum" @changePageNumber="changePageNumber" ></my-folder-page-number>
      <div style="width: 100%" :style="{'height' : showCgSlogan ? 'calc(20% - 60px)' : '20%'}"></div>
    </div>
    <div v-if="detailCardShow" class="detail-info-card">
      <div style="height: 54px;line-height: 54px;border-bottom: 1px solid rgba(84,84,84,1);display: flex">
        <p class="ml-4 detail-card-title">{{ detailInfo.fileName }}</p>
        <p @click="closeFileDetail" style="cursor:pointer;color: rgba(196,196,196,1);font-size: 12px;margin-left: 18px"
           class="iconfontFamily">
          &#xe659;</p>
      </div>
      <div style="padding: 17px">
        <p style="font-size: 14px;color: rgba(166,166,166,1)">创作者</p>
        <div style="height: 55px;display: flex;align-items: center" v-if="detailInfo.authority === 0">
          <div style="width: 30px;height: 30px;"
               class="avatar-icon"
               :style="{'background-image': 'url(' + detailInfo.avatar + ')'}">
          </div>
          <p style="color: white;margin-left: 10px">{{ detailInfo.nickName }}</p>
        </div>
        <div style="height: 55px;display: flex;align-items: center" v-if="detailInfo.authority === 1">
          <div class="detail-item-key" style="display: flex;align-items: center">
            <div v-for="(item, index) in detailInfo.teamList" :key="index">
              <div class="avatar-icon"
                   :style="{'background-image': 'url(' + item + ')', 'margin-left': index === 0 ? '0' : '-10px'}">
              </div>
            </div>
          </div>
          <p @click="openTeamManage" class="detail-item-value" style="cursor: pointer;color: rgba(97,171,255,1)">
            团队管理</p>
        </div>
        <div>
          <div style="display: flex">
            <p class="detail-item-key">类型</p>
            <p class="detail-item-value">{{ detailInfo.authority === 0 ? '个人文件' : '团队文件' }}</p>
          </div>
          <div style="display: flex">
            <p class="detail-item-key">对象数量</p>
            <p class="detail-item-value">{{ detailInfo.labelCount }}</p>
          </div>
          <div style="display: flex">
            <p class="detail-item-key">更新时间</p>
            <p class="detail-item-value">{{ detailInfo.gmtModifytime }}</p>
          </div>
          <div style="display: flex">
            <p class="detail-item-key">创建时间</p>
            <p class="detail-item-value">{{ detailInfo.gmtCreatetime }}</p>
          </div>
          <div style="margin-top: 10px;display: flex;overflow: hidden">
            <p style="width: 30%;font-size: 14px;color: rgba(166, 166, 166, 1);height: 100%;">使用说明</p>
            <p style="width: 70%;font-size: 16px;color: rgba(255, 255, 255, 1);line-height: 21px;word-break: break-word;height: auto">无</p>
          </div>
          <div style="margin-top: 15px;display: flex;overflow: hidden">
            <p style="width: 30%;font-size: 14px;color: rgba(166, 166, 166, 1);height: 100%;">文件简介</p>
            <p style="width: 70%;font-size: 16px;color: rgba(255, 255, 255, 1);height: 100%;line-height: 21px">无</p>
          </div>
        </div>

      </div>
    </div>
    <div @click="uploadFile" class="upload-btn" :style="{'bottom' : showCgSlogan ? '70px' : '15px'}">
      <p class="iconfontFamily" style="color: white;font-size: 16px;">&#xe64c;</p>
      <p class="alibabaPuHuiTiFontFamily" style="color: white;margin-left: 14px">文件上传</p>
    </div>
    <div v-if="showCgSlogan" class="YouSheBiaoTiHei cg-slogan">
      <p style="margin-left: 35px;font-size: 24px;color: white">什么是CG?</p>
      <p @click="showCgSlogan = !showCgSlogan" class="iconfontFamily"
         style="position: absolute;right: 6px;top: -16px;color: rgba(196,196,196,1);font-size: 12px">&#xe60d;</p>
    </div>
    <file-rename-dialog v-if="showWholeRenameDialog" :original-file-name="originalFileName"
                        :original-file-id="originalFileId" :show-file-rename-dialog="showRenameDialog"
                        @searchInputEnter="searchInputEnter"
                        @closeRenameDialog="closeRenameFileDialog"></file-rename-dialog>
    <upload-file-dialog v-if="showDialog" :dialog-show="showUploadDialog" @hideUploadDialog="hideUploadDialog"
                        @searchInputEnter="searchInputEnter" @hideWholeDialog="hideWholeDialog"></upload-file-dialog>
    <delete-file-dialog :dialog-show="showDeleteSingleFileDialog"
                        @closeDeleteFileDialog="closeDeleteSingleFileDialog"
                        @deleteFileOK="deleteSingleFileOK"></delete-file-dialog>
    <delete-file-dialog :dialog-show="showDeleteMultiFileDialog"
                        @closeDeleteFileDialog="closeDeleteMultiFileDialog"
                        @deleteFileOK="deleteMultiFileOK"></delete-file-dialog>
    <transfer-team-file-dialog v-if="showWholeTransferDialog" :transfer-file-dialog-show="transferFileDialogShow"
                               :original-file-name="originalFileName"
                               :original-file-id="originalFileId"
                               @closeWholeTransferDialog="closeWholeTransferDialog"
                               @searchInputEnter="searchInputEnter"></transfer-team-file-dialog>
    <download-file-dialog v-if="showWholeDownloadDialog" :download-file-dialog-show="downloadFileDialogShow"
                          @closeDownloadDialog="closeDownloadDialog"
                          @confirmDownload="confirmDownload"></download-file-dialog>
    <member-list-dialog-for-file-manage v-if="memberListDialogShow" :dialogShow="memberListDialogShow" :curr-folder-id="teamFileId" :folder-name="teamFolderName"
                        :file-read-only="teamFileReadOnly" :members-save-files="allowMembersSaveFiles" :members-export-files="allowMembersExportFiles" :members-invite-others="allowMembersInviteOthers"
                        @closeDialog="closeMemberListDialog"
                        @teamFileRenameOk="teamFileRenameOk"
                        @dissolveTeamOk="dissolveTeamOk"></member-list-dialog-for-file-manage>
    <share-file-dialog v-if="showShareFileDialog" :show-share-file-dialog="showShareFileDialog" :share-link="shareLink" :shareQRCode="shareQRCode" :fileId="selectedFileId" @closeShareFileDialog="closeShareFileDialog"></share-file-dialog>
  </div>
</template>
<script>
import UploadFileDialog from "@/views/globe/dialog/file_manage/UploadFileDialog.vue";
import FileRenameDialog from "@/views/globe/dialog/file_manage/FileRenameDialog.vue";
import DeleteFileDialog from "@/views/globe/dialog/file_manage/DeleteFileDialog.vue";
import TransferTeamFileDialog from "@/views/globe/dialog/file_manage/TransferTeamFileDialog.vue";
import DownloadFileDialog from "@/views/globe/dialog/file_manage/DownloadFileDialog.vue";
import MemberListDialog from "@/views/globe/dialog/MemberListDialog.vue";
import ShareFileDialog from "@/views/globe/dialog/file_manage/ShareFileDialog.vue";
import MemberListDialogForFileManage from "@/views/globe/dialog/file_manage/MemberListDialogForFileManage.vue";
import PageNumber from "@/components/page_number/PageNumber.vue";
import MyFolderPageNumber from "@/components/page_number/MyFolderPageNumber.vue";
export default {
  name: "MainMyFolder",
  components: {
    MyFolderPageNumber,
    PageNumber,
    ShareFileDialog,
    MemberListDialog, MemberListDialogForFileManage,
    DownloadFileDialog, TransferTeamFileDialog, DeleteFileDialog, FileRenameDialog, UploadFileDialog,
  },
  watch: {
    '$store.state.filterField': {
      handler: function (newVal, oldVal) {
        this.currPageNum = 1
        this.clearJumpNumber()
        this.searchInputEnter()
      }
    },
    '$store.state.orderType': {
      handler: function (newVal, oldVal) {
        this.clearJumpNumber()
        this.searchInputEnter()
      }
    },
    '$store.state.orderField': {
      handler: function (newVal, oldVal) {
        this.clearJumpNumber()
        this.searchInputEnter()
      }
    },
    currPageNum: {
      handler: function (newVal, oldVal) {
        this.searchInputEnter()
      }
    }
  },
  data() {
    return {
      searchKeyword: '',
      currPageNum: 1,
      maxResultNum: 10,
      totalPageNum: 0,
      orderFieldList: ['更新时间', '创建时间', '标记数量'],
      isOrderListFolded: true,
      isFilterFolded: true,
      totalFileList: [],
      showFileList: [],
      showCgSlogan: false,
      selectedFileId: '',
      teamFileId: '',
      teamFileReadOnly: '',        // 团队文件管理相关
      teamFolderName: '',        // 团队文件管理相关
      allowMembersExportFiles: '', // 团队文件管理相关
      allowMembersSaveFiles: '',   // 团队文件管理相关
      allowMembersInviteOthers: '',// 团队文件管理相关
      selectedFileInfo: '',
      showUploadDialog: false,
      showDialog: '',
      showRenameDialog: false,
      originalFileName: '',
      originalFileId: '',
      showWholeRenameDialog: false,
      showDeleteSingleFileDialog: false,
      deleteFileId: '',
      transferFileDialogShow: false,
      showWholeTransferDialog: false,
      detailCardShow: false,
      detailCardFileId: '',
      detailInfo: {
        authority: '',
        fileName: '',
        avatar: '',
        nickName: '',
        teamList: [],
        labelCount: '',
        gmtModifytime: '',
        gmtCreatetime: '',
        introduction: '',
      },
      maxFileNameCharacter: 30,
      isBatchDeleteFiles: false,
      multiSelectedFileId: [],
      showDeleteMultiFileDialog: false,
      downloadFileDialogShow: false,
      showWholeDownloadDialog: false,
      downloadUrls: [],
      memberListDialogShow: false,
      showShareFileDialog: false,
      shareLink: '',
      shareQRCode: ''
    }
  },
  methods: {
    changePageNumber(param) {
      this.currPageNum = param
    },
    clearJumpNumber() {
      if (this.$refs.myFolderPageNumber) {

        this.$refs.myFolderPageNumber.clearJumpNumber()
      }
    },
    searchInputEnter() {
      this.$axios({
        method: 'get',
        url: '/authorApi/z-geo-file/getFileListWithTeam',
        params: {
          keyWord: this.searchKeyword,
          orderField: this.$store.state.orderField,
          orderType: this.$store.state.orderType,
          curPageNum: this.currPageNum,
          maxResultNum: this.maxResultNum,
          fileType: this.$store.state.filterField
        }
      }).then((resp) => {
        resp = resp.data
        if (resp.status === 200) {
          this.totalFileList = resp.data['list']
          this.showFileList = this.totalFileList
          this.totalPageNum = resp.data['totalPageNum'] // 分页总页数
        } else {
          console.log('status = ' + resp.status + ' message = ' + resp.message)
        }
      })
    },
    selectFile(item) {
      this.selectedFileInfo = item
      let id = item['fileId']
      if (this.isBatchDeleteFiles) {
        // 多选
        if (item['authority'] === 1) {
          // 团队文件不参与多选
          return
        }
        let idx = this.multiSelectedFileId.indexOf(id)
        if (idx > -1) {
          this.multiSelectedFileId.splice(idx, 1)
        } else {
          this.multiSelectedFileId.push(id)
        }
        return
      }
      if (item['authority'] === 1) {
        // 记录团队文件的相关信息
        this.teamFileId = item['fileId']
        this.teamFolderName = item['fileName']
        this.teamFileReadOnly = item['teamReadonly']
        this.allowMembersSaveFiles = item['teamSave'] === 1
        this.allowMembersExportFiles = item['teamExport'] === 1
        this.allowMembersInviteOthers =  item['teamInvite'] === 1
      }
      this.selectedFileId = id
    },
    getFirstMarker(fileGeo) {
      // bfs获取最浅层的节点geo信息
      let queue = []
      for (let i = 0; i < fileGeo.length; i++) {
        queue.push(fileGeo[i])
      }
      while (queue.length  !== 0) {
        let layerCount = queue.length
        for (let i = 0; i < layerCount; i++) {
          let curr = queue.shift()
          if (curr.type !== 'folder') {
            return [curr.geoJson.geo, curr.type]
          } else {
            for (let j = 0; j < curr.children.length; j++) {
              queue.push(curr.children[j])
            }
          }
        }
      }
    },
    async showFileDetail(item) {
      // 跳转到对应的位置 + 展示标记信息
      // 找到第一个文件/文件夹的最近的元素
      let fileGeo = ''
      await this.$axios.get('/authorApi/z-geo-file/openFile', {
        params: {
          'fileId': item['fileId']
        }
      }).then((resultData) => {
        resultData = resultData.data;
        console.log(resultData)
        if (resultData.status === 200) {
          fileGeo = resultData.data.content
        } else {
          console.log(resultData.status + resultData.message);
        }
      })
      this.detailCardShow = true
      this.detailCardFileId = item['fileId']
      this.detailInfo.fileName = item['fileName']
      this.detailInfo.authority = item['authority']
      this.detailInfo.avatar = item['avatar']
      this.detailInfo.nickName = item['nickName']
      this.detailInfo.labelCount = item['labelCount']
      this.detailInfo.gmtModifytime = item['gmtModifytime']
      this.detailInfo.gmtCreatetime = item['gmtCreatetime']
      this.detailInfo.teamList = item['teamList']
      this.detailInfo.introduction = item['introduction']
      this.$emit('showMyFolderEditIcon', item)
      if (fileGeo === undefined || fileGeo.length === 0) {
        // 无标记不飞 还是飞向初始位置
        return
      }
      let firstMarkerGeoAndType = this.getFirstMarker(fileGeo)
      this.$emit('flyToFolderFirstMarker', firstMarkerGeoAndType[0], firstMarkerGeoAndType[1])
    },
    closeFileDetail() {
      this.detailCardShow = false
      this.detailCardFileId = ''
    },
    shareFile(item) {
      this.$axios({
        method: 'get',
        url: '/authorApi/z-geo-file/shareFile',
        params: {
          fileId: item['fileId']
        }
      }).then((resp) => {
        resp = resp.data
        if (resp.status === 200) {
          this.shareLink = resp.data['shareFileUrl']
          this.shareQRCode = resp.data['shareFileQrCode']
          this.showShareFileDialog = true
        } else {
          console.log('获取分享链接失败')
        }
      })
    },
    closeShareFileDialog() {
      this.showShareFileDialog = false
    },
    backupFile(item) {
      if (item['fileName'].length > this.maxFileNameCharacter - 3) {
        this.$store.state.snackbarShow = true
        this.$store.state.snackbarType = 'error'
        this.$store.state.snackbarText = '文件备份名过长'
        return
      }
      let params = new FormData()
      params.append('fileId', item['fileId'])
      this.$store.state.snackbarShow = true
      this.$store.state.snackbarType = 'info'
      this.$store.state.snackbarText = '文件备份中'
      this.$axios({
        method: 'post',
        url: '/authorApi/z-geo-file/fileBackup',
        data: params
      }).then((resp) => {
        resp = resp['data']
        if (resp['status'] === 200) {
          this.$store.state.snackbarShow = true
          this.$store.state.snackbarType = 'success'
          this.$store.state.snackbarText = '备份完成'
          this.searchInputEnter()
        }
      })
    },
    downloadFile() {
      this.showWholeDownloadDialog = true
      this.downloadFileDialogShow = true
    },
    confirmDownload(fileType) {
      this.closeDownloadDialog()
      let params = new FormData()
      params.append('fileId', this.selectedFileId)
      params.append('exportFormat', fileType)
      this.$axios({
        method: 'post',
        url: '/authorApi/z-geo-file/fileDownload',
        data: params
      }).then((resp) => {
        //获取接口返回的文件流并下载（目前接口返回的是object）
        // let url = window.URL.createObjectURL(new Blob([resp]));
        // let link = document.createElement('a')
        // link.style.display = 'none'
        // link.href = url
        // let filename = "test." + fileType
        // link.download = filename;
        // document.body.appendChild(link)
        // link.click()
        // document.body.removeChild(link) // 下载完成移除元素
        // window.URL.revokeObjectURL(url) // 释放掉blob对象

        //原本接口返回下载链接的相应代码
        resp = resp.data
        if (resp.status === 200) {
          this.downloadUrls = resp['data']
          this.exportFolderOk(this.downloadUrls)
        } else {
          this.$store.state.snackbarShow = true
          this.$store.state.snackbarText = "获取文件下载地址失败"
          this.$store.state.snackbarType = 'error'
          console.log('获取文件下载url失败')
        }
      })

      // //直接通过a标签访问接口下载内容，但是无法拼接header登录信息
      // const pp = '/authorApi/z-geo-file/fileDownload?fileId=' + this.selectedFileId + '&exportFormat=' + fileType
      // console.log(pp)
      // let filename = "test." + fileType
      // const downloadLink = document.createElement('a');
      // downloadLink.href = pp;
      // downloadLink.download = filename
      // document.body.appendChild(downloadLink);
      // downloadLink.click(); // 模拟用户点击下载链接
      // document.body.removeChild(downloadLink);

    },
    exportFolderOk(fileDownloadUrl) {
      for (let i = 0; i < fileDownloadUrl.length; i++) {
        const iframe = document.createElement("iframe");
        iframe.style.display = "none"; // 防止影响页面
        iframe.style.height = 0; // 防止影响页面
        iframe.src = fileDownloadUrl[i];
        document.body.appendChild(iframe); // 这一行必须，iframe挂在到dom树上才会发请求
        setTimeout(() => {
          iframe.remove();
        }, 1000);
      }
      this.exportFolderShow = false;
    },
    closeDownloadDialog() {
      this.showWholeDownloadDialog = false
      this.downloadFileDialogShow = false
    },
    openTeamManage() {
      this.memberListDialogShow = true
    },
    closeMemberListDialog() {
      this.memberListDialogShow = false
      this.detailCardShow = false
      this.searchInputEnter()
    },
    teamFileRenameOk() {
      this.searchInputEnter()
    },
    dissolveTeamOk() {
      this.memberListDialogShow = false
      this.$store.state.globeQuitShowDialog = false;
      this.searchInputEnter()
      if (this.teamFileId === this.detailCardFileId) {
        this.closeFileDetail()
        this.$emit('setOriginalPositionAndClearLayers')
      }
      if (this.teamFileId === this.$store.state.currFolderId) {
        this.$emit('deleteOpenFile')
      }
    },
    confirmMultiFileDelete() {
      this.showDeleteMultiFileDialog = true
    },
    cancelMultiFileDelete() {
      this.isBatchDeleteFiles = false
    },
    transferToTeamFile(item) {
      this.originalFileName = item['fileName']
      this.originalFileId = item['fileId']
      this.showWholeTransferDialog = true
      this.transferFileDialogShow = true
      this.detailCardShow = false
    },
    closeWholeTransferDialog() {
      this.transferFileDialogShow = false
      this.showWholeTransferDialog = false
    },
    renameFile(item) {
      this.showWholeRenameDialog = true
      this.showRenameDialog = true
      this.originalFileName = item['fileName']
      this.originalFileId = item['fileId']
    },
    closeRenameFileDialog() {
      this.showWholeRenameDialog = false
      this.showRenameDialog = false
    },
    deleteFile(item) {
      this.showDeleteSingleFileDialog = true
      this.deleteFileId = item['fileId']
    },
    closeDeleteSingleFileDialog() {
      this.showDeleteSingleFileDialog = false
    },
    deleteSingleFileOK() {
      let params = new FormData()
      params.append('fileId', this.deleteFileId)
      this.$axios({
        method: "post",
        url: "/authorApi/z-geo-file/deleteFile",
        data: params
      }).then((resultData) => {
        resultData = resultData.data;
        if (resultData.status === 200) {
          this.$store.state.snackbarShow = true
          this.$store.state.snackbarText = "删除完成"
          this.$store.state.snackbarType = 'success'
          if (this.deleteFileId === this.detailCardFileId) {
            this.closeFileDetail()
            this.$emit('setOriginalPositionAndClearLayers')
          }
          if (this.deleteFileId === this.$store.state.currFolderId) {
            this.$emit('deleteOpenFile')
          }
          this.searchInputEnter()
          this.closeDeleteSingleFileDialog()
        } else {
          console.log(resultData.status + resultData.message);
        }
      }).catch((err) => {
        console.log(err);
      });
    },
    deleteMultiFile() {
      this.multiSelectedFileId = []
      this.closeFileDetail()
      this.isFilterFolded = !this.isFilterFolded
      this.isBatchDeleteFiles = true
      this.selectedFileId = ''
    },
    closeDeleteMultiFileDialog() {
      this.showDeleteMultiFileDialog = false
    },
    deleteMultiFileOK() {
      let params = new FormData()
      params.append('fileIdList', this.multiSelectedFileId)
      this.$axios({
        method: 'post',
        url: '/authorApi/z-geo-file/deleteFiles',
        data: params
      }).then((resp) => {
        resp = resp.data
        if (resp.status === 200) {
          this.$store.state.snackbarShow = true
          this.$store.state.snackbarText = "批量删除完成"
          this.$store.state.snackbarType = 'success'
          this.searchInputEnter()
          this.isBatchDeleteFiles = false
          if (this.multiSelectedFileId.indexOf(this.detailCardFileId) > -1) {
            this.closeFileDetail()
            this.$emit('setOriginalPositionAndClearLayers')
          }
          // 删除了打开的文件
          if (this.multiSelectedFileId.indexOf(this.$store.state.currFolderId) > -1) {
            this.$emit('deleteOpenFile')
          }
          this.closeDeleteMultiFileDialog()
        } else {
          console.log('status = ' + resp.status + ' message = ' + resp.message)
        }
      })
    },
    // 下面三个是上传窗口相关
    uploadFile() {
      this.showDialog = true
      this.showUploadDialog = true
    },
    hideUploadDialog() {
      this.showUploadDialog = false
    },
    hideWholeDialog() {
      this.showDialog = false // 修改了这里,整个dialog不见
    },
  },
  mounted() {
    this.searchInputEnter()
  },
  destroyed() {
    this.$emit("leftBarDestroy", "myFolder")
  },
}
</script>

<style scoped>

.mainMyFolder {
  height: 100%;
  width: 340px;
  padding: 14px 15px 0 15px;
  position: relative;
}

.order-menu {
  position: absolute;
  width: 120px;
  height: 208px;
  border-radius: 3px;
  background-color: rgba(56, 56, 56, 1);
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.25);
  left: 25px;
  top: 50px;
  z-index: 1;
}

.filter-menu {
  position: absolute;
  width: 120px;
  height: 176px;
  border-radius: 3px;
  background-color: rgba(56, 56, 56, 1);
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.25);
  right: -90px;
  z-index: 2;
  top: 50px;
}

.order-item {
  display: flex;
  line-height: 36px;
  height: 36px;
  align-items: center;
  cursor: pointer;
}

.order-item:hover {
  background-color: rgba(32, 81, 138, 1);
}

.card-item {
  width: 310px;
  margin-bottom: 14px;
  border-radius: 8px;
  border: 1px solid rgba(128, 128, 128, 1);
  background-color: rgba(56, 56, 56, 1);
  position: relative;
//cursor: pointer; display: block;
}

.card-item:hover {
//border: 1px solid rgba(97,171,255,1);
}

.avatar-icon {
  border-radius: 50%;
  width: 22px;
  height: 22px;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
}

.file-name {
  padding: 14px;
  width: 100%;
}

.card-item:hover .file-name {
  width: 77%;
}

.hover-show {
  display: none;
}

.card-item:hover .hover-show {
  display: block;
  text-align: center;
  margin-top: 20px;
  width: 23%;
  cursor: pointer;
  height: 30px;
  margin-right: 10px
}

.team-icon {
  width: 38px;
  height: 22px;
  border-radius: 2px;
  background-color: rgba(0, 122, 108, 1);
  color: white;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
}

::-webkit-scrollbar {
  display: none;
}

.page-divider {
  display: flex;
  align-items: center;
  width: 100%;
  height: 35px
}

.detail-info-card {
  width: 300px;
  height: auto;
  min-height: 520px;
  border-radius: 2px;
  background-color: rgba(56, 56, 56, 1);
  box-shadow: 4px 4px 10px 1px rgba(0, 0, 0, 0.25);
  position: absolute;
  left: 355px;
  top: 10px;
  z-index: 1;
}

.detail-card-title {
  color: white;
  width: 80%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.detail-item-key {
  width: 30%;
  font-size: 14px;
  color: rgba(166, 166, 166, 1);
  height: 38px;
  line-height: 38px;
}

.detail-item-value {
  width: 70%;
  font-size: 16px;
  color: rgba(255, 255, 255, 1);
  height: 38px;
  line-height: 38px
}

.upload-btn {
  display: flex;
  position: absolute;
  align-items: center;
  justify-content: center;
  z-index: 10;
  bottom: 80px;
  width: 130px;
  left: 50%;
  transform: translateX(-50%);
  border-radius: 21px;
  background-color: rgba(0, 111, 237, 1);
  line-height: 42px;
  margin: 0 auto;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.5);
  cursor: pointer;
}

.cg-slogan {
  width: 340px;
  height: 60px;
  line-height: 60px;
  position: absolute;
  bottom: 0;
  left: 0;
  background-image: url('../../../assets/file_manage/cg_slogen.png');
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  cursor: pointer;
}

:deep(.el-checkbox__inner) {
  background-color: transparent;
}
</style>

<style>
.myPaginationRounded .v-pagination__item {
  height: 22px;
  min-width: 22px;
  font-size: 12px;
  border-radius: 50%;
}

.myPaginationRounded .v-pagination__navigation {
  width: 22px;
  height: 22px;
  min-width: 22px;

  border-radius: 50%
}

.myPaginationRounded .v-pagination__more {
  color: #ffffff;
  align-items: normal;
}

</style>